import React from 'react'

const HPLogo = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1066.667 1066.667"
      width="100%"
      height="100%"
      {...props}
    >
      <defs>
        <clipPath id="a" clipPathUnits="userSpaceOnUse">
          <path d="M-400 0h800v-800h-800Z" />
        </clipPath>
        <clipPath id="b" clipPathUnits="userSpaceOnUse">
          <path d="M-624.152 286.698h800v-800h-800Z" />
        </clipPath>
      </defs>
      <path
        d="M0 0c-220.934 0-400-179.089-400-399.998C-400-620.924-220.934-800 0-800s400 179.076 400 400.002C400-179.089 220.934 0 0 0"
        clipPath="url(#a)"
        style={{
          fill: "#fff",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none",
        }}
        transform="matrix(1.33333 0 0 -1.33333 533.334 0)"
      />
      <path
        d="M0 0h-58.984l-82.618-226.673h59.001L.017 0Zm-224.152-483.772c-3.687 0-7.357.068-11.011.171l75.707 208.081h104.194c18.284 0 38.368 14.064 44.611 31.233L71.487-18.661c13.43 36.944-7.718 67.165-47.029 67.165h-144.552l-121.278-333.286h-.051l-68.76-188.922c-163.11 38.779-284.439 185.406-284.439 360.402 0 174.996 114.434 313.15 270.444 356.8l-70.956-194.994h-.017l-117.95-324.007h78.519L-334.281-.172h59.001l-100.301-275.331h78.485l93.475 256.859c13.446 36.944-7.718 67.165-46.978 67.165h-65.999l75.792 208.252c5.523.241 11.063.395 16.654.395 204.599 0 370.471-165.871 370.471-370.47 0-204.599-165.872-370.47-370.471-370.47"
        clipPath="url(#b)"
        style={{
          fill: "#024ad8",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none",
        }}
        transform="matrix(1.33333 0 0 -1.33333 832.202 382.264)"
      />
    </svg>
  )
}

export default HPLogo
